function bindMouseOverToMegaMenu(item, allItems) {
  item.addEventListener("mouseover", () => {
    allItems.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });

    item.setAttribute("open", true);

    item
      .querySelector(".mega-menu__content")
      .addEventListener("mouseover", () => {
        item.setAttribute("open", true);
      });

    item
      .querySelector(".mega-menu__content")
      .addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
  });
}

let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details.mega-menu");

items.forEach((item) => bindMouseOverToMegaMenu(item, items));
